import async from "./Async";

// Lazily loaded pages
const Liveliness = async(() => import("../../pages/Liveliness/CaptureVideo"));

const applicationLayoutRoutes = {
  livelinessPageRoute: {
    ID: "liveliness",
    path: "/liveliness/",
    element: Liveliness,
  },
};

export default applicationLayoutRoutes;
